import { useEffect, useState } from "react";
import { getConsumos } from '../../services/ConsumosService';
// Graficos desactivados para OSPM. Se conservan para una futura reactivacion.
// import { fetchDistribucionMensual } from '../../services/ConsumosService';
// import ChartConsumos from "./components/ChartConsumos";
// import ChartDistribucion from "./components/ChartDistribucion";
import EstadosSelect from "./components/EstadosSelect";
import MonthSelect from "./components/MonthSelect";
import TiposSelect from "./components/TipoSelect";
import "./Consumos.css";
import Cards from "./components/Cards/Cards";
import ConsumosResults from "./ConsumosResults";

function Consumos() {
    const [selectedMonth, setSelectedMonth] = useState("16");
    const [month, setMonth] = useState("16");
    const [selectedEstado, setSelectedEstado] = useState("Consumido");
    const [estado, setEstado] = useState("Consumido");
    const [selectedTipo, setSelectedTipo] = useState(0);
    const [tipo, setTipo] = useState(0);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState({ consultaActual: 0, cantidad: 10 });
    const [dataTable, setDataTable] = useState({ data: [], loading: true });
    // const [distribucionData, setDistribucionData] = useState([]);
    const [loadingTable, setLoadingTable] = useState(false);
    const [nroAfiliado, setNroAfiliado] = useState('');
    const [filtersOpen, setFiltersOpen] = useState(false);
    const [idAfiliado, setIdAfiliado] = useState(0);

    /* FETCH DE GRAFICOS DESACTIVADO
    useEffect(() => {
        fetchDataChartData();
    }, [])

    const fetchDataChartData = async () => {
        setLoading(true);
        try {
            const [dataChart] = await Promise.all([
                fetchDistribucionMensual({periodo: month, idAfiliado: idAfiliado, estado: estado} ),
            ]);

            setDistribucionData(dataChart);
        } catch (error) {
            setDistribucionData([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchDataChartDataWithSelectedMonth = async () => {
        setLoading(true);
        try {
            const [dataChart] = await Promise.all([
                fetchDistribucionMensual({periodo: month, idAfiliado: idAfiliado, estado: estado} ),
            ]);

            setDistribucionData(dataChart);
        } catch (error) {
            setDistribucionData([]);
        } finally {
            setLoading(false);
        }
    };
    */

    //FETCH SI CAMBIÁS EL SELECT DEL MES O FILTROS APLICADOS
    useEffect(() => {
        fetchData();
    }, [month, estado, tipo, idAfiliado])

    const fetchData = async () => {
        setLoading(true);
        try {
            const [dataTableResult] = await Promise.all([
                getConsumos({ page: 0, size: page.cantidad, periodo: month, tipo: tipo, idAfiliado: idAfiliado, estado: estado }),
            ]);

            //TABLA
            setDataTable({ data: dataTableResult, loading: false });
            setPage({ ...page, consultaActual: 0 });
            setLoadingTable(false);
        } catch (error) {
            setDataTable({ data: [], loading: false });
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (event) => {
        const soloNumeros = event.target.value.replace(/[^0-9]/g, '');
        setNroAfiliado(soloNumeros);
    };

    const handleFetch = async () => {
        setLoading(true);
        const newMonth = selectedMonth;
        const newTipo = selectedTipo;
        const newEstado = selectedEstado;
        setMonth(newMonth);
        setTipo(newTipo);
        setEstado(newEstado);

        try {
            const newIdAfiliado = nroAfiliado ? parseInt(nroAfiliado) : 0;
            setIdAfiliado(newIdAfiliado);

            const [dataTableResult] = await Promise.all([
                getConsumos({
                    page: 0,
                    size: page.cantidad,
                    periodo: newMonth,
                    tipo: newTipo,
                    idAfiliado: newIdAfiliado,
                    estado: newEstado
                }),
            ]);

            setDataTable({ data: dataTableResult, loading: false });
            setPage({ ...page, consultaActual: 0 });
        } catch (error) {
            setDataTable({ data: [], loading: false });
        } finally {
            setLoading(false);
        }
    };

    const refreshParameters = async () => {
        setSelectedMonth("16");
        setMonth("16");
        setSelectedEstado("Consumido");
        setEstado("Consumido");
        setSelectedTipo(0);
        setTipo(0);
        setNroAfiliado('');
        setIdAfiliado(0);
        setPage({ consultaActual: 0, cantidad: 10 });

        setLoading(true);

        try {
            const [dataTableResult] = await Promise.all([
                getConsumos({
                    page: 0,
                    size: 10,
                    periodo: "16",
                    tipo: 0,
                    idAfiliado: 0,
                    estado: "Consumido"
                }),
            ]);

            setDataTable({ data: dataTableResult, loading: false });
        } catch (error) {
            setDataTable({ data: [], loading: false });
        } finally {
            setLoading(false);
        }
    };

    //FETCH PARA LA TABLA SOLO PAGINADO - NO CAMBIA EL MES
    useEffect(() => {
        if (loadingTable && !loading) {
            retrieveDataTableData();
        }
    }, [loadingTable, loading]);

    const retrieveDataTableData = async () => {
        try {
            const dataTableResult = await getConsumos({
                page: page.consultaActual,
                size: page.cantidad,
                periodo: month,
                tipo: tipo,
                idAfiliado: idAfiliado,
                estado: estado
            });
            setDataTable({ data: dataTableResult, loading: false });
        } catch (error) {
            setDataTable({ data: [], loading: false });
        } finally {
            setLoadingTable(false);
        }
    };

    const handlePageChange = (nextPage) => {
        setPage((current) => ({ ...current, consultaActual: nextPage }));
        setLoadingTable(true);
    };

    const handlePageSizeChange = (cantidad) => {
        setPage({ consultaActual: 0, cantidad });
        setLoadingTable(true);
    };

    return (
        <>
            <div className="page-content">
                <div className="controls-section">
                    <div className="flex flex-col bg-white rounded-2xl shadow-sm w-full">
                        <div
                            className="px-6 py-4 border-b border-gray-200 flex items-center justify-between cursor-pointer select-none hover:bg-gray-50 transition-colors rounded-t-2xl"
                            onClick={() => setFiltersOpen(o => !o)}
                        >
                            <h2 className="text-xl font-semibold text-gray-800">Filtros</h2>
                            <span style={{fontSize:'12px',color:'#9ca3af'}}>{filtersOpen ? '▲' : '▼'}</span>
                        </div>

                        {filtersOpen && <>
                        <div className="px-6 py-4">
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                                <div className="flex flex-col">
                                    <label className="text-sm font-medium text-gray-700 mb-2">Mes</label>
                                    <MonthSelect
                                        distribucionData={[]}
                                        value={selectedMonth}
                                        onChange={setSelectedMonth}
                                    />
                                </div>

                                <div className="flex flex-col">
                                    <label className="text-sm font-medium text-gray-700 mb-2">Estado</label>
                                    <EstadosSelect
                                        setSelectedEstado={setSelectedEstado}
                                        selectedEstado={selectedEstado}
                                    />
                                </div>

                                <div className="flex flex-col">
                                    <label className="text-sm font-medium text-gray-700 mb-2">Tipo</label>
                                    <TiposSelect
                                        setSelectedEstado={setSelectedTipo}
                                        selectedEstado={selectedTipo}
                                    />
                                </div>

                                <div className="flex flex-col">
                                    <label className="text-sm font-medium text-gray-700 mb-2">Numero Asociado o DNI</label>
                                    <input
                                        type="text"
                                        value={nroAfiliado}
                                        onChange={handleChange}
                                        placeholder="0"
                                        className="font-sans py-2 px-4 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#B04708] focus:border-transparent transition duration-150"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="px-6 py-4 flex justify-end gap-3">
                            <button
                                onClick={refreshParameters}
                                className="bg-gray-500 hover:bg-gray-600 text-white font-medium py-2 px-6 rounded-md transition-all duration-150 hover:scale-105 disabled:opacity-50"
                            >
                                Limpiar
                            </button>
                            <button
                                onClick={handleFetch}
                                className="bg-[#B04708] hover:bg-[#8a3606] text-white font-medium py-2 px-6 rounded-md transition-all duration-150 hover:scale-105 disabled:opacity-50"
                                disabled={loading}
                            >
                                Buscar
                            </button>
                        </div>
                        </>}
                    </div>
                </div>

                <Cards periodo={month} tipo={tipo} estado={estado} idAfiliado={idAfiliado}/>

                {/* Graficos desactivados; tampoco se ejecutan sus llamadas a API.
                <div className="section">
                    {tipo === 0 && (
                        <ChartConsumos mes={month} data={distribucionData} isConsumido={estado === "Consumido"} loading={loading} />
                    )}
                    <ChartDistribucion periodo={month} tipo={tipo} idAfiliado={idAfiliado} estado={estado} />
                </div>
                */}

                <div className="section">
                    <ConsumosResults
                        data={dataTable.data}
                        estado={estado}
                        loading={loadingTable || loading}
                        pagination={page}
                        onPageChange={handlePageChange}
                        onPageSizeChange={handlePageSizeChange}
                    />
                </div>
            </div>
        </>
    );
}

export default Consumos;
